// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialDetailsLogs_base__2QQhI","filters":"TrialDetailsLogs_filters__1JsoP"};